import { render, staticRenderFns } from "./StudentMondayItem.vue?vue&type=template&id=6d60074a&scoped=true&"
import script from "./StudentMondayItem.vue?vue&type=script&lang=js&"
export * from "./StudentMondayItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentMondayItem.vue?vue&type=style&index=0&id=6d60074a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60074a",
  null
  
)

export default component.exports